module.exports = __webpack_public_path__ + "media/images/store/project-supplies-eba42ffd003eef9e97478c3077a71d52.png";